import Swiper from 'swiper';
import {FreeMode} from 'swiper/modules';

export function initHeroBlocks(root = document) {
    const heroBlocks = root.querySelectorAll('.vicenza-hero');

    heroBlocks.forEach((heroBlock) => {
        const layerA = heroBlock.querySelector('.hero-bg-layer--a');
        const layerB = heroBlock.querySelector('.hero-bg-layer--b');
        const slides = heroBlock.querySelectorAll('.hero-swiper-slide');
        const swiperEl = heroBlock.querySelector('.hero-swiper');
        const ctaLink = heroBlock.querySelector('.hero-cta');
        const ctaLabel = heroBlock.querySelector('.hero-cta__label');

        if (!layerA || !layerB) return;

        let slidesData = [];
        try {
            const slidesAttr = heroBlock.dataset.slides;
            if (slidesAttr) {
                slidesData = JSON.parse(slidesAttr);
            }
        } catch (e) {
            console.warn('Failed to parse slides data:', e);
        }

        let activeLayer = 'a';
        let currentIndex = 0;
        let heroAutoplayTimer = null;
        const AUTOPLAY_DELAY = 4000;
        const PINNED_THUMBS = 2;
        let swiperInstance = null;
        let ctaTimer = null;

        /**
         * Scrolls the thumbnail rail to ensure the active thumbnail is visible.
         * @param index
         */
        function scrollThumbRailTo(index) {
            if (!swiperInstance || swiperInstance.destroyed) return;
            if (index < PINNED_THUMBS) {
                swiperInstance.slideTo(0);
                return;
            }
            swiperInstance.slideTo(index - (PINNED_THUMBS - 1));
        }

        /**
         * Cross-fades the hero background to a new image URL.
         */
        function crossFadeTo(url) {
            if (!url) return;
            if (activeLayer === 'a') {
                layerB.style.backgroundImage = `url(${url})`;
                layerB.classList.add('is-visible');
                layerA.classList.remove('is-visible');
                activeLayer = 'b';
            } else {
                layerA.style.backgroundImage = `url(${url})`;
                layerA.classList.add('is-visible');
                layerB.classList.remove('is-visible');
                activeLayer = 'a';
            }
        }

        /**
         * Update CTA URL/text/target according to the active slide.
         */
        function updateCTAAnimated(slideIndex, withAnimation = true) {
            if (!ctaLink || !ctaLabel || !slidesData[slideIndex]) {
                return;
            }
            const slideData = slidesData[slideIndex];
            if (!withAnimation) {
                applyCtaData(slideData);
                return;
            }
            ctaLink.classList.add('is-leaving');
            if (ctaTimer) clearTimeout(ctaTimer);
            ctaTimer = setTimeout(() => {
                applyCtaData(slideData);
                ctaLink.classList.remove('is-leaving');
                ctaLink.classList.add('is-preparing');
                void ctaLink.offsetWidth;
                ctaLink.classList.remove('is-preparing');
            }, 300);
        }

        /**
         * Applies the CTA data from the slide to the CTA link and label.
         * @param slideData
         */
        function applyCtaData(slideData) {
            ctaLink.href = slideData.link || '#';
            ctaLabel.textContent = slideData.link_text || '';
            if (slideData.link_target) {
                ctaLink.setAttribute('target', slideData.link_target);
            } else {
                ctaLink.removeAttribute('target');
            }
            if (slideData.link_target === '_blank') {
                ctaLink.setAttribute('rel', 'noopener noreferrer');
            } else {
                ctaLink.removeAttribute('rel');
            }
        }

        /**
         * Sets the active slide and updates the background and CTA accordingly.
         * @param index
         * @param withFade
         */
        function setActiveSlide(index, withFade = true) {
            currentIndex = index;
            const slide = slides[index];
            const slideData = slidesData[index];
            if (!slide || !slideData) return;
            slides.forEach((s) => s.classList.remove('is-active'));
            slide.classList.add('is-active');
            if (withFade) {
                crossFadeTo(slideData.bg);
            } else {
                layerA.style.backgroundImage = `url(${slideData.bg})`;
                layerA.classList.add('is-visible');
                layerB.classList.remove('is-visible');
                activeLayer = 'a';
            }
            updateCTAAnimated(index, withFade);
            scrollThumbRailTo(index);
        }

        /**
         * Autoplay Logic for the Hero Backgrounds
         */
        function startHeroAutoplay() {
            stopHeroAutoplay();
            if (slides.length <= 1) return;
            heroAutoplayTimer = setInterval(() => {
                const nextIndex = (currentIndex + 1) % slides.length;
                setActiveSlide(nextIndex, true);
            }, AUTOPLAY_DELAY);
        }

        /**
         * Autoplay Logic for the Hero Backgrounds
         */
        function stopHeroAutoplay() {
            if (heroAutoplayTimer) {
                clearInterval(heroAutoplayTimer);
            }
        }

        slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                setActiveSlide(index, true);
                startHeroAutoplay();
            });
        });

        if (slidesData.length > 0) {
            setActiveSlide(0, false);
        }

        if (swiperEl && slides.length > 1) {
            swiperInstance = new Swiper(swiperEl, {
                modules: [FreeMode],
                slidesPerView: 'auto',
                spaceBetween: 10,
                freeMode: {
                    enabled: true,
                    sticky: false,
                },
                grabCursor: true,
            });
        }

        startHeroAutoplay();
        heroBlock.addEventListener('mouseenter', stopHeroAutoplay);
        heroBlock.addEventListener('mouseleave', startHeroAutoplay);
        heroBlock.classList.add('is-ready');
    });
}